// ---- Furniture: shared palette + helpers ----
// Common colours, the build-ctx alias, and the wall-mount offset used by every
// furniture piece (both the generic set in common.ts and the heraldic/castle set
// in heraldic.ts). Keeping them here lets the two themed files share one palette
// without a circular import.

import type { StructureBuildCtx } from "../define.ts";
import { shade } from "../../color.ts";

export type Ctx = StructureBuildCtx;

// --- shared palette ---
export const WOOD = 0x6b4a2f;            // dark oak
export const WOOD_LT = shade(WOOD, 0.14);
export const WOOD_DK = shade(WOOD, -0.16);
export const GOLD = 0xc9a23a;
export const IRON = 0x35363c;
export const CUSHION = 0x7d1f2b;         // deep red velvet
export const STONE_DAIS = 0x8f8980;
export const RUG_FIELD = 0x8c2f2f;       // heraldic red
export const RUG_BORDER = 0x274076;      // royal blue
export const RUG_MOTIF = GOLD;
export const CLOTH_BLUE = 0x2f4a8c;
export const CLOTH_RED = 0xb23a48;
export const CLOTH_GREEN = 0x2f6b45;
export const CANDLE = 0xf3e7c4;
export const FLAME = 0xffb24a;
export const EMBER = 0xff7a2a;            // glowing coals in a hearth
export const SOOT = 0x1a1714;             // firebox shadow
export const LINEN = 0xece6d8;            // pale bedding
export const ERMINE_PILLOW = 0xf6f3ec;    // bright white pillows
// Spine colours cycled across bookshelf rows.
export const BOOK_COLS = [0x8c2f2f, 0x2f4a8c, 0x2f6b45, 0x7a5a2a, 0x5a2f6b, 0x9a7320];

// How far a wall hanging is mounted proud of the wall's INNER FACE so it clears
// the inner cobble veneer (~0.22 into the room) instead of z-fighting it.
export const WALL_MOUNT = 0.32;
